import React, { ReactElement, useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import { Spinner, Navigation, Filtering, Tile, Section } from "../../components"
import { useGetExperiencesByCategory } from "../../Hooks"
import { getTimeFromMin } from "../../lib"
import { sendPageTrackingEvent } from "../../services"

import styles from "./Koudpouces.scss"

const KoudpoucesPage = ({  }: RouteComponentProps) => {
  function renderTiles(children: Experience[]) {
    const sections: ReactElement[] = []
    children.forEach(
      (
        { name, price, sessions, pics, sessionsNumber }: Experience,
        i: number
      ) => {
        sections.push(
          <Tile
            key={name}
            index={i}
            title={name}
            sessionsNumber={sessionsNumber}
            duration={getTimeFromMin(
              sessions.map(s => s.duration).reduce((curr, acc) => acc + curr)
            )}
            picture={pics[0]}
            price={price}
          />
        )
      }
    )
    return <div id="experiences">{sections}</div>
  }

  const [loading, setLoading] = useState<boolean>(true)
  // const [filter, setFilter] = useState<Date>(new Date())
  const [searchedLocation, setSearchedLocation] = useState<{
    lat: string
    lng: string
  }>({})
  const [radius, setRadius] = useState<number>(30)
  // const [filterIndex, setFilterIndex] = useState<number>(0)
  const [categories, setCategories] = useState<[string]>([])
  const [selectedCategory, setSelectedCategory] = useState<string>("Tous")

  // const experiences = filterExperiencesByDate(filter, filterIndex, setLoading)
  sendPageTrackingEvent("Experiences")
  const experiences = useGetExperiencesByCategory(
    "koudpouce",
    setLoading,
    selectedCategory,
    radius,
    searchedLocation
  )
  useEffect(() => {
    if (categories.length === 0) {
      setCategories([...new Set(experiences.map(exp => exp.category))])
      window.scrollTo(0, 0)
    }
  }, [experiences])
  return (
    <>
      <Navigation animated={false} />
      <Section title="LES KOUDPOUCES POUR APPROFONDIR">
        {loading ? (
          <Spinner />
        ) : (
          <div className={styles.center}>
            <Filtering
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              setSearchedLocation={setSearchedLocation}
            />
            {/* {renderFilteringButtons(setFilter, setFilterIndex, filterIndex)} */}
            <div>{renderTiles(experiences)}</div>
          </div>
        )}
      </Section>
    </>
  )
}

export default KoudpoucesPage
